import { TranslationChunksConfig, TranslationResources } from '@spartacus/core';
import { en } from './en';
import { fr_CA } from './fr_CA';

export const AtgTranslations: TranslationResources = {
   en,
   fr_CA
};

export const AtgTranslationChunksConfig: TranslationChunksConfig = {
   atgUserManagement: ['atgUserManagement'],
   atgHomepageMyOrders: ['atgHomepageMyOrders'],
   atgProduct: ['atgProduct'],
};